// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__v1fke","inner":"Footer_inner__3aW6f","nextIcon":"Footer_nextIcon__2gHEk","innerLeft":"Footer_innerLeft__18J0S"};